export const formatPrice = (amount, i18n, withsymbol=true, nagitive=false) => {
    const input = false;
    const num = Number(amount);
    const safeNum = amount === null || amount === undefined || amount === "null" || !Number.isFinite(num) || (num < 0 && !nagitive) ? 0 : num;
    let lang;
    try {
        lang = i18n?.resolvedLanguage || i18n?.language || localStorage.getItem("i18nextLng") || localStorage.getItem("language");
    } catch (e) {
    }
    if (!lang && typeof window !== 'undefined' && window.i18n) {
        lang = window.i18n.language;
    }

    if(withsymbol){
        lang = lang || "en";
    }
    else{
        lang = "en";
    }

    const localeMap = {
        nl: "nl-NL",
        en: "en-US",
        fr: "fr-FR",
        de: "de-DE",
        ar: "ar-AE",
    };

    const locale = localeMap[lang] || "en-US";
    let finalPrice = safeNum;
    const formattedAmount = new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(finalPrice);

    if (input) {
        return Math.floor(finalPrice).toLocaleString("en-US");
    }

    let symbol = "€" || "";
    if (!symbol) {
        try {
            const stored = localStorage.getItem("userCurrency");
            const userCurrency = stored ? JSON.parse(stored) : null;
            symbol = userCurrency && userCurrency.symbol ? userCurrency.symbol : "";
        } catch (e) {
            symbol = "€";
        }
    }

    if(withsymbol){
        return `${symbol} ${formattedAmount}`;
    }
    else{
        return `${formattedAmount}`;
    }
};

export const getFinalPrice = (amount) => {
    const num = Number(amount);
    let finalPrice = Number.isFinite(num) ? num : 0;
    return Number(finalPrice.toFixed(2));
};

export const formatFinalAmount = (finalPrice, i18n, withsymbol = true) => {
    const num = Number(finalPrice);
    let lang;
    try {
        lang = i18n?.resolvedLanguage || i18n?.language || localStorage.getItem("i18nextLng") || localStorage.getItem("language");
    } catch (e) {}
    if (!lang && typeof window !== 'undefined' && window.i18n) {
        lang = window.i18n.language;
    }
    const localeMap = {
        nl: "nl-NL",
        en: "en-US",
        fr: "fr-FR",
        de: "de-DE",
        ar: "ar-AE",
    };
    const locale = localeMap[lang] || "en-US";

    const formattedAmount = new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(Number.isFinite(num) ? num : 0);

    if (withsymbol) {
        let symbol = import.meta.env.VITE_CURRENCY_SYMBOL || "";
        if (!symbol) {
            try {
                const stored = localStorage.getItem("userCurrency");
                const userCurrency = stored ? JSON.parse(stored) : null;
                symbol = userCurrency && userCurrency.symbol ? userCurrency.symbol : "€";
            } catch (e) {
                symbol = "€";
            }
        }
        return `${symbol} ${formattedAmount}`;
    }

    return `${formattedAmount}`;
};
